import React from 'react'
import { PublicPageButton } from 'src/public-pages/shared/components/public-page-button'
import { PublicPageHeading } from 'src/public-pages/shared/components/public-page-heading'
import { PublicPageText } from 'src/public-pages/shared/components/public-page-text'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import { Error404Icon } from 'src/shared/icons/error-404-icon'
import {
  WebsiteButtonsInterface,
  WebsiteThemeInterface,
  WebsiteTypographySettingsStylesInterface,
} from 'src/shared/types/website-settings-types'

export interface NotFoundContentProps {
  homePageUrl?: string
  heading?: WebsiteTypographySettingsStylesInterface
  paragraph?: WebsiteTypographySettingsStylesInterface
  theme?: WebsiteThemeInterface
  button?: Partial<WebsiteButtonsInterface>
  isButtonShown?: boolean
}

export const NotFoundContent = ({
  homePageUrl = '/',
  heading,
  paragraph,
  theme,
  button,
  isButtonShown,
}: NotFoundContentProps) => {
  const accentColor = theme?.buttons.primaryButtonBackgroundColor

  const redirect = () => {
    window.location.href = homePageUrl
  }
  const { t } = useTypedTranslation()

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
      }}
    >
      <Error404Icon fill={accentColor} />

      <PublicPageHeading
        heading={heading}
        theme={theme}
        style={{ marginBottom: '24px', maxWidth: '700px' }}
      >
        {t('website_public_page.not_found_content.title')}
      </PublicPageHeading>

      <PublicPageText
        paragraph={paragraph}
        theme={theme}
        textAlign="center"
        style={{
          maxWidth: '440px',
          ...(isButtonShown ? { marginBottom: '24px' } : {}),
        }}
      >
        {t('website_public_page.not_found_content.sub_title')}
      </PublicPageText>

      {isButtonShown && (
        <PublicPageButton
          button={button}
          theme={theme}
          text={t('website_public_page.thank_you_content.button_text')}
          onClick={redirect}
          paragraph={paragraph}
        />
      )}
    </div>
  )
}
